import { useDispatch } from "react-redux"
import { ScrollTrigger, useGSAP } from "@repo/utils/gsap"
import { setIsMenuTransparent } from "@/state/menuSlice"
import { useNavigation } from "../providers/NavigationProvider"

export default function useSetTransparentMenu(ref, forceChangeValueOnInit = false) {
	const dispatch = useDispatch()

	function handleSetTheme(isTransparent) {
		dispatch(setIsMenuTransparent(isTransparent))
	}

	useGSAP(
		() => {
			if (!ref.current) return

			const top = forceChangeValueOnInit ? "top-=1 top" : "top top"

			if (forceChangeValueOnInit) {
				handleSetTheme(true)
			}

			ScrollTrigger.create({
				trigger: ref.current,
				start: top,
				onEnter: () => handleSetTheme(true),
				onEnterBack: () => handleSetTheme(true),
				onLeave: () => handleSetTheme(false),
				onLeaveBack: (self) => {
					handleSetTheme(self.start <= 0)
				},
			})
		},
		{ dependencies: [], scope: ref },
	)
}
